import logo from "@/assets/img/logo-login.svg";
import bgFlowerLeft from "@/assets/img/bg-flower-left.svg";
import bgFlowerRight from "@/assets/img/bg-flower-right.svg";

export default function AccessDenied() {
  return (
    <div className="w-full h-full flex justify-end bg-background text-secondary">
      <div
        className="flex-1 flex items-center justify-center bg-no-repeat bg-contain"
        style={{
          backgroundPosition: `left, right`,
          backgroundImage: `url(${bgFlowerLeft}), url(${bgFlowerRight})`,
        }}
      >
        <img src={logo} className="w-1/2" />
      </div>
      <div className="bg-white p-28 w-[40vw]">
        <h1 className="text-3xl font-bold">Acessar quiz</h1>
        <p className="text-red-400 text-lg font-bold my-4">
          Em breve você poderá responder o quiz outra vez.
        </p>
        <p className="text-red-400 text-lg font-bold mb-4">
          Tente novamente mais tarde.
        </p>
      </div>
    </div>
  );
}
